import { render, staticRenderFns } from "./recipe-list.vue?vue&type=template&id=3c9ae1a0&scoped=true&"
import script from "./recipe-list.vue?vue&type=script&lang=js&"
export * from "./recipe-list.vue?vue&type=script&lang=js&"
import style0 from "./recipe-list.vue?vue&type=style&index=0&id=3c9ae1a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9ae1a0",
  null
  
)

export default component.exports